import { useAuth0 } from '@auth0/auth0-react';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { treatmentPlanV3Actions } from '../../../../../../store';

import type { AppDispatch } from '../../../../../../store';

export default function useFetchTreatmentPlanV3MedicalPage() {
  const dispatch = useDispatch<AppDispatch>();
  const { getAccessTokenSilently } = useAuth0();
  const { treatmentPlanId } = useParams<'treatmentPlanId'>();
  const retry = useCallback(() => {
    if (treatmentPlanId) void dispatch(treatmentPlanV3Actions.getTreatmentPlanV3MedicalPage({ treatmentPlanId, getAccessTokenSilently }));
  }, [dispatch, getAccessTokenSilently, treatmentPlanId]);
  useEffect(() => retry(), [retry]);
  return { retry };
}
